var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3827_48247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4 7.29204L20.708 5.60004L14 12.308L7.29204 5.60004L5.60004 7.29204L12.308 14L5.60004 20.708L7.29204 22.4L14 15.692L20.708 22.4L22.4 20.708L15.692 14L22.4 7.29204Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3827_48247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6,
    height: 19.6,
    fill: "white",
    transform: "translate(4.20001 4.20001)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotificationIcon);
export default __webpack_public_path__ + "static/media/error-notification-icon.4e882a52106edb5ee68b2f1e3887e464.svg";
export { ForwardRef as ReactComponent };